<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()
</script>

<template>
  <div v-if="toasts.length > 0" class="toast-list">
    <div v-for="toast in toasts" :key="toast.id" class="toast-container" :class="toast.type">
      <div class="toast-content">
        <div class="toast-message body-sm">{{ toast.message }}</div>
        <img
          class="svg-24"
          src="@/assets/svgs/close.svg"
          alt="close"
          @click="removeToast(toast.id)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.toast-list {
  position: fixed;
  top: 100px;
  right: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 9999;
}

.toast-container {
  width: 335px;
  padding: 20px;
  background-color: var(--gray-100);
  border-radius: 8px;
  box-sizing: border-box;
}

.toast-container.error {
  background-color: var(--tint-100);
}

.toast-message {
  white-space: pre-line;
}

.toast-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.svg-24 {
  cursor: pointer;
}

@media (max-width: 1365px) {
  .toast-list {
    position: fixed;
    bottom: 24px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: end;
    flex-direction: column;
    gap: 16px;
    z-index: 9999;
  }
}
</style>
